import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import PanelContent from '@portal/components/PanelContent/PanelContent';

import { getRouteStackPath } from '@portal/config/routes';
import { translate } from '@portal/services/i18n';

import { PageClass } from '@portal/enum/analytics';
import { sendEvent } from '@portal/services/firebase';
import CreateAccountDock from './CreateAccountDock/CreateAccountDock';
import Details from './Details/Details';
import Invoice from './Invoice/Invoice';
import MyCards from './MyCards';
import RequestCard from './RequestCard/RequestCard';
import Tracking from './Tracking/Tracking';

const CardsNavigationStack = () => {
  const location = useLocation();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.ESCROW,
    });
  }, [location]);

  return (
    <Switch>
      <Route exact path={getRouteStackPath('CARDS', 'REQUEST_CARD')}>
        <PanelContent pageTitle={translate('PAGES.NEW_CARD.PAGE_TITLE')}>
          <RequestCard />
        </PanelContent>
      </Route>
      <Route exact path={getRouteStackPath('CARDS', 'MY_CARDS_PAGE')}>
        <PanelContent pageTitle={translate('PAGES.CARDS.PAGE_TITLE')}>
          <MyCards />
        </PanelContent>
      </Route>
      <Route exact path={getRouteStackPath('CARDS', 'MY_CARD_DETAILS')}>
        {({ match }) => (
          <PanelContent pageTitle={translate('PAGES.CARDS.PAGE_TITLE')}>
            <Details key={match?.params?.id} />
          </PanelContent>
        )}
      </Route>
      <Route exact path={getRouteStackPath('CARDS', 'MY_CARD_INVOICE')}>
        <PanelContent pageTitle={translate('PAGES.CARDS.PAGE_TITLE')}>
          <Invoice />
        </PanelContent>
      </Route>
      <Route exact path={getRouteStackPath('CARDS', 'TRACKING_CARD')}>
        <PanelContent
          pageTitle={translate('PAGES.CARDS.MY_CARDS.TRACKING_CARD.TITLE')}
        >
          <Tracking />
        </PanelContent>
      </Route>
      <Route exact path={getRouteStackPath('CARDS', 'ACCOUNT_ON_DOCK_PAGE')}>
        <PanelContent
          pageTitle={translate('PAGES.CARDS.MY_CARDS.ACCOUNT.TITLE')}
        >
          <CreateAccountDock />
        </PanelContent>
      </Route>
    </Switch>
  );
};

export default CardsNavigationStack;
